import { RegisterRequest, SessionResponse, User } from '../types/auth'
import { apiClient } from './apiClient'

class AuthService {
  async login(name: string, last4: string): Promise<SessionResponse> {
    try {
      const response = await apiClient.post<SessionResponse>('/api/v1/public/auth/login', {
        name,
        last4,
      })
      return response.data
    } catch (error) {
      console.error('Login failed:', error)
      throw error
    }
  }

  async register(userData: RegisterRequest): Promise<SessionResponse> {
    const response = await apiClient.post<SessionResponse>('/api/v1/public/auth/register', userData)
    return response.data
  }

  // OAuth deprecated

  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get('/api/v1/auth/me')
    return response.data
  }

  async updateProfile(userData: Partial<User>): Promise<User> {
    const response = await apiClient.put('/api/public/auth/profile', userData)
    return response.data
  }

  async logout(): Promise<void> {
    await apiClient.post('/api/v1/auth/logout')
  }

  async refreshAccessToken(): Promise<void> {
    await apiClient.post('/api/v1/auth/refresh')
  }

  // Phone number login for Korean users
  async loginWithPhone(phoneNumber: string, verificationCode?: string): Promise<SessionResponse> {
    const response = await apiClient.post('/api/public/auth/phone/login', {
      mobile_number: phoneNumber,
      verification_code: verificationCode,
    })
    return response.data
  }

  async sendPhoneVerification(phoneNumber: string): Promise<void> {
    await apiClient.post('/api/public/auth/phone/send-code', {
      mobile_number: phoneNumber,
    })
  }
}

export const authService = new AuthService()